export default "__VITE_ASSET__4d36ee42__"